/* src/app/account/partials/inactive-accounts/inactive-accounts.component.scss */
/*# sourceMappingURL=inactive-accounts.component.css.map */
